import Icon from '../components/Icon.vue'

Icon.register({
  blind: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M380.1 510.8c-1.1 0.6-2.9 1.2-4.2 1.2-2.5 0-5.5-1.7-6.8-3.8l-125.3-206.4c4.3-1.7 10.1-5.9 13-9.5l126 207.6c0.6 1.1 1.2 2.9 1.2 4.2 0 2.5-1.7 5.5-3.8 6.8zM142.8 314.3l62.8 153.5c6.7 16.4-1.1 35-17.5 41.7-16.4 6.7-35-1.1-41.7-17.5l-36.1-88.3zM96 88c-24.3 0-44-19.7-44-44s19.7-44 44-44 44 19.7 44 44-19.7 44-44 44zM250.8 257.1c8.2 10.4 6.4 25.5-4 33.7-9.3 7.4-24.6 7.6-33.7-4l-102.3-129.2c-0.7-0.8-2.1-1.5-3.1-1.5-2.2 0-4 1.8-4 4 0 0.8 0.4 1.9 0.9 2.5l31.4 39.8v107.2l-65.9 181.3c-6 16.6-24.4 25.2-41 19.1-16.6-6-25.2-24.4-19.1-41l54.1-148.7v-140.7l-16 20.6v79.8c0 13.1-10.5 23.7-23.5 24-13.5 0.3-24.5-11.1-24.5-24.5v-95.7l61.1-78.5c4.7-6.1 11.8-9.2 18.9-9.2v0h32v0c7.1 0 14.1 3.1 18.8 9.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blind.js
// module id = 667
// module chunks = 0